import { addDays, format, parseISO } from 'date-fns';
import pt from 'date-fns/locale/pt';
import { isNumericId } from 'utils/numericId';
import api from './api';

const requireNumericId = (value, message) => {
  if (!isNumericId(value)) {
    throw new Error(message);
  }
  return String(value).trim();
};

// TODO: formatar no back
export const selectProntuarioById = async (payload) => {
  const id = requireNumericId(payload, 'Código da consulta inválido.');
  const { data } = await api.get(`prontuario/${id}`);

  const prontuario = {
    ...data,
    dataFormatada:
      data.DATACONSULTA &&
      format(addDays(parseISO(data.DATACONSULTA), 1), 'dd/MM/yyyy', {
        locale: pt,
      }),
    dataNasc:
      data.DTNPAC &&
      format(addDays(parseISO(data.DTNPAC), 1), 'dd/MM/yyyy', {
        locale: pt,
      }),
    idadePAC: Math.floor(
      (parseISO(data.DATACONSULTA) - parseISO(data.DTNPAC)) / (1000 * 3600 * 24) / 365.25
    ),
  };

  return prontuario;
};

// TODO: formatar no back
export const selectProntuariosByPac = async (payload) => {
  const codPac = requireNumericId(payload, 'Código do paciente inválido.');
  const { data } = await api.get(`prontuarios/paciente/${codPac}`);
  const prontuarios = data.map((p) => ({
    ...p,
    dataFormatada:
      p.DATACONSULTA &&
      format(addDays(parseISO(p.DATACONSULTA), 1), 'dd/MM/yyyy', {
        locale: pt,
      }),
    dataNasc:
      p.DTNPAC &&
      format(addDays(parseISO(p.DTNPAC), 1), 'dd/MM/yyyy', {
        locale: pt,
      }),
    idadePAC: Math.floor(
      (parseISO(p.DATACONSULTA) - parseISO(p.DTNPAC)) / (1000 * 3600 * 24) / 365.25
    ),
  }));
  return prontuarios;
};

export const updateProntuario = async (id, payload) => {
  const codConsulta = requireNumericId(id, 'Código da consulta inválido.');
  const { data } = await api.put(`prontuario/${codConsulta}`, payload);
  return data;
};

export const storeProntuario = async (payload) => {
  const { data } = await api.post('prontuario', payload);
  return data;
};
